import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { PaziaButton, PaziaInput } from "components/atoms";
import { settingsApi } from "api";
import { useInvalidateSettings } from "api/hooks/useInvalidateSettings";
import { useToaster } from "utils";

export interface AutopaySettingsFormProps {
  serviceId: string;
  autopayApiUrl: string;
}

export const AutopaySettingsForm = ({ serviceId, autopayApiUrl }: AutopaySettingsFormProps) => {
  const { showError, showSuccess } = useToaster();
  const invalidateSettings = useInvalidateSettings();
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      serviceId,
      autopayApiUrl,
      sharedKey: "",
    },
  });

  const onSubmit = async (values: AutopaySettingsValues) => {
    try {
      await settingsApi.saveAutopay({ ...values, sharedKey: values.sharedKey || undefined });
      await invalidateSettings();
      showSuccess("Zapisano ustawienia Autopay");
    } catch (error) {
      showError("Błąd podczas zapisywania ustawień Autopay");
    }
  };

  const {
    handleSubmit,
    formState: { isDirty, errors },
  } = methods;

  return (
    <FormProvider {...methods}>
      <form className="flex flex-col gap-2" onSubmit={handleSubmit(onSubmit)}>
        <PaziaInput label="ServiceID Autopay" name="serviceId" />
        <PaziaInput label="Adres API Autopay" name="autopayApiUrl" />
        <PaziaInput
          label="SharedKey Autopay"
          name="sharedKey"
          type="password"
          placeholder="Pozostaw puste, aby nie zmieniać"
        />
        <div>
          <PaziaButton
            type="success"
            disabled={!isDirty}
            title="Zapisz"
            className={Object.keys(errors).length ? "mb-[26px]" : ""}
          />
        </div>
      </form>
    </FormProvider>
  );
};

const schema = yup
  .object({
    serviceId: yup.string().required(),
    autopayApiUrl: yup.string().required(),
    sharedKey: yup.string().optional(),
  })
  .required();

export type AutopaySettingsValues = yup.InferType<typeof schema>;
